!function(window) {
function treeMapChart(options) {

	let initialized = false;

	// bind filter events 
	var $filterWrapper = $('.iopr-data-wrapper .filter-wrapper.tree-map').on('submit', 'form', function (ev) {
		ev.preventDefault();
		var $form = $(this);
		$form.find('button[type="submit"]').prop('disabled', true);
		handleTreeMapFilter($form);
	});

	// because filter option is disabled by default
	// we need to check dropdown change event and enable it if needed
	$filterWrapper.find('.iopr-select').each(function (i, item) {
		var $select = $(item);

		$select.on('changed.bs.select', function (e) {
			var val = e.currentTarget.value;
			var $formSubmit = $select.closest('form').find('button[type="submit"]');
			var $form = $select.closest('form');
			if (!val) {
				$formSubmit.prop('disabled', true);
			} else {
				if (!initialized) {
					$formSubmit.removeAttr('disabled');
					initialized = true;
				}
				$(".tree-data-wrapper").removeClass('hidden');
				handleTreeMapFilter($form);
				$('.stacked-area-chart').fadeIn();
			}
		});
	});

	// handles filter submit
	function handleTreeMapFilter($form) {
		//show loader

		// hide table
		if (!options.html.tree.tableWrapper.hasClass('not-shown')) {
			options.html.tree.tableWrapper.fadeOut(function () {
				options.html.tree.tableWrapper.addClass('not-shown');
				options.html.tree.tableWrapper.html('');
			})
		}

		// hide previous data
		if (!options.html.tree.chartData.hasClass('not-shown')) {
			options.html.tree.chartData.fadeOut(function () {
				options.html.tree.chartData.addClass('not-shown');
				options.html.tree.chartData.html('');
			});
		}


		// show loader
		if (options.html.tree.chartLoader.hasClass('not-shown')) {
			options.html.tree.chartLoader.fadeIn(function () {
				options.html.tree.chartLoader.removeClass('not-shown');
				var ajaxBody = setTreeMapAjaxBody($form);
				$.post(options.base.apiIncludeLng(), ajaxBody, function (data) {

					// DO STUFF WITH BODY CALL GOOGLE
					var dataJson = JSON.parse(data);

					// HIDE LOADER
					if (!options.html.tree.chartLoader.hasClass('not-shown')) {
						options.html.tree.chartLoader.fadeOut(function () {
							options.html.tree.chartLoader.addClass('not-shown');

							// SHOW DATA
							// table
							options.html.tree.tableWrapper.html(dataJson.table);
							options.html.tree.tableWrapper.fadeIn(function () {
								if (options.properties.useConfirm) {
									options.elements.tableModal = $('#tableRowAddRemoveModal');
								}
								options.html.tree.tableWrapper.removeClass('not-shown');
							})

							// chart
							options.data.tree.baseData = dataJson.treemap;
							options.data.tree.currentData = dataJson.treemap.slice(0);

							options.html.tree.tableWrapper.fadeIn(function () {
								options.html.tree.tableWrapper.removeClass('not-shown');
							});

							options.html.tree.chartData.fadeIn(function () {
								options.html.tree.chartData.removeClass('not-shown');
								options.charts.tree.generate(false);
							});
						});
					}
				});

			});
		}


		function generateGoogleChart(fadeInOut = false) {
			options.methods.triggerStartProcessing('tree');

			if (fadeInOut) {
				// hide previous data
				if (!options.html.tree.chartData.hasClass('not-shown')) {
					options.html.tree.chartData.fadeOut(function () {
						options.html.tree.chartData.addClass('not-shown');
					});
				}
				// show loader
				if (options.html.tree.chartLoader.hasClass('not-shown')) {
					options.html.tree.chartLoader.fadeIn(function () {
						options.html.tree.chartLoader.removeClass('not-shown');
					});
				}
			}

			options.data.tree.currentGoogleData = google.visualization.arrayToDataTable(options.data.tree.currentData);

			if (options.charts.tree.chart) {
				options.charts.tree.chart.clearChart();
				options.charts.tree.chart = null;
			}

			options.charts.tree.chart = new google.visualization.TreeMap(options.html.tree.chartData[0]);

			// define function to be executed on window resize
			options.charts.tree.resize = () => {
				options.charts.tree.chart.draw(options.data.tree.currentGoogleData, options.charts.tree.options);
				if (options.charts.tree.properties.selected) {
					options.charts.tree.chart.setSelection(options.charts.tree.properties.selected);
				}
			};

			// bind events
			google.visualization.events.addListener(options.charts.tree.chart, 'select', () => {
				adjustStackedAreaChart();
				setStrokeColor();
			});
			google.visualization.events.addListener(options.charts.tree.chart, 'rollup', () => {
				adjustStackedAreaChart();
				setStrokeColor();
			});

			if (!fadeInOut) {
				// else when removing nodes it will get triggered again
				google.visualization.events.addListener(options.charts.tree.chart, 'ready', () => {
					options.properties.setParent({
						v: '-1',
						f: 'section'
					});
					options.charts.stackedArea.validateFilter();
					setStrokeColor();
				});
				options.charts.tree.properties.selected = null;
				options.methods.triggerEndProcessing('tree');
			} else {
				google.visualization.events.addListener(options.charts.tree.chart, 'ready', () => {
					options.methods.triggerEndProcessing('tree');
				});
			}

			options.charts.tree.chart.draw(options.data.tree.currentGoogleData, options.charts.tree.options);
			if (fadeInOut && options.charts.tree.properties.selected) {
				options.charts.tree.chart.setSelection(options.charts.tree.properties.selected);
			}

			if (fadeInOut) {
				options.html.tree.chartLoader.fadeOut(function () {
					options.html.tree.chartLoader.addClass('not-shown');
					options.html.tree.chartData.fadeIn(function () {
						options.html.tree.chartData.removeClass('not-shown');
					});
				});
			}

			
		}

		function adjustStackedAreaChart() {
			const selected = options.charts.tree.chart.getSelection();
			options.charts.tree.properties.selected = selected;
			if (selected && selected.length) {
				const row = selected[0].row != null ? selected[0].row : null;
				if (row != null) {
					options.properties.setParent(options.data.tree.currentGoogleData.wg[row]['c'][0]);
					options.charts.stackedArea.travelLevels();
				}
			}
		}

		function setStrokeColor() {
			$('.tree-map rect').eq($('.tree-map rect').length - 1).attr('stroke', "#f5f5f5");
		}

		function goBackInChart() {
			var btn = $('.back-in-graf').show();
			$(btn).on('click', () => {
				options.charts.tree.chart.goUpAndDraw();
				adjustStackedAreaChart();
				setStrokeColor();
			});
		}
		goBackInChart();

		function setTreeMapAjaxBody($form) {
			// get year
			var obj = {};
			obj['cashFlow'] = options.properties.cashFlow;
			obj['type'] = options.properties.type;
			obj['dataType'] = 'tree-map';
			if (options.properties.type == 'month') {
				obj['period'] = $form.find('input[name="helper-period"]').val();
				obj['subPeriod'] = $form.find('#period-selector').val();

			} else if (options.properties.type == 'year-final') {
				obj['period'] = $form.find('#period-selector').val();
			}
			return obj;
		}

		// set function for generating google chart
		options.charts.tree.generate = generateGoogleChart;
	}

}

module.exports = treeMapChart;
window.treeMapChart = treeMapChart;
}.call(window, window);